import { useMemo } from "react";
import { Tooltip } from "@mui/material";

interface CustomButtonProps {
    id?: string;
    title?: string;
    children?: React.ReactNode;
    type?: "button" | "submit" | "reset";
    color?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "link" | "";
    size?: "sm" | "lg";
    outline?: boolean;
    onClick?: () => void;
    className?: string;
    isLoading?: boolean;
    icon?: React.ReactNode;
    iconPlacement?: "start" | "end";
    disabled?: boolean;
    active?: boolean;
    style?: React.CSSProperties;
}

const CustomButton: React.FC<CustomButtonProps> = ({
    id,
    title = "",
    children = <></>,
    type = "button",
    color = "primary",
    size = "",
    outline = false,
    onClick = () => { },
    className = "",
    isLoading = false,
    icon = false,
    iconPlacement = "start",
    disabled = false,
    style = {},
    active = false,
}) => {
    const btnClassName = useMemo(() => {
        let str = "btn";
        if (color) str += ` btn-${outline ? `outline-` : ""}${color}`;
        if (size) {
            str += ` btn-${size}`;
        }

        str += " " + className;
        return str;
    }, [className, color, outline, size]);

    return (
        <Tooltip title={title}>
            <button
                id={id}
                type={disabled || isLoading ? "button" : type}
                className={`${btnClassName} ${active ? "active" : ""} ${disabled || isLoading ? "disabled" : ""}`}
                onClick={disabled || isLoading ? () => { } : onClick}
                style={style}
            >
                <div className="flex justify-center items-center">
                    {!isLoading ? (
                        <>
                            {icon && iconPlacement === "start" && (
                                <span className="me-2">{icon}</span>
                            )}
                            {children}
                            {icon && iconPlacement === "end" && (
                                <span className="ms-2">{icon}</span>
                            )}
                        </>
                    ) : (
                        <>
                            <div
                                className="spinner-border small spinner-border-sm me-2"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <span>Loading...</span>
                        </>
                    )}
                </div>
            </button>
        </Tooltip>
    );
};

export default CustomButton;
